import { Injectable } from '@angular/core';
import { FormElementBuilderService } from '../FormElementBuilder/form-element-builder.service';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import type { FormUserData } from 'src/app/interfaces/PWA/Forms';
import type { IDynamicFormHiddenElement } from 'src/app/interfaces/Outputs/DynamicFormHiddenElement';
import type { IDynamicFormElement } from 'src/app/interfaces/Outputs/DynamicFormElement';
@Injectable({
  providedIn: 'root',
})
export class FormControlService {
  private listeners: any[] = [];

  constructor(private readonly builder: FormElementBuilderService) {}

  async modelToFormGroup(
    fields: IDynamicFormElement[],
    cachedData?: FormUserData
  ): Promise<FormGroup> {
    const group: { [key: string]: FormControl | FormGroup } = {};
    await this.removeSubs();
    fields.forEach((field) => {
      const element_value = cachedData?.[field.id_elemento]?.value ?? '';
      const control = this.builder.setField(field).build(element_value);
      if (control) {
        group[field.id_elemento] = control;
      }
    });

    const form = new FormGroup(group);

    this.addDependencyListeners(form, fields);

    return form;
  }

  async removeSubs() {
    if (this.listeners.length > 0) {
      this.listeners.forEach((sub) => {
        if (sub) {
          sub.unsubscribe();
        }
      });
    }
    return;
  }

  addDependencyListeners(form: FormGroup, fields: IDynamicFormElement[]): void {
    fields.forEach((field) => {
      if (field.dependency) {
        const dependentFieldId =
          field.dependency.id_elemento_dependiente.toString();
        const dependentFieldControl = form.get(dependentFieldId);
        const currentFieldControl = form.get(field.id_elemento.toString());

        if (dependentFieldControl && currentFieldControl) {
          const dependencyValues =
            field.dependency.valor_dependencia.split(';');
          const sub = dependentFieldControl.valueChanges.subscribe((value) => {
            this.checkDependency(value, dependencyValues, currentFieldControl);
          });

          this.listeners.push(sub);
          this.checkDependency(
            dependentFieldControl.value,
            dependencyValues,
            currentFieldControl
          );
        }
      }
    });
  }

  private checkDependency(
    value: string,
    dependencyValues: string[],
    fieldControl: AbstractControl
  ): void {
    if (dependencyValues.includes(value)) {
      fieldControl.enable();
    } else {
      fieldControl.disable();
    }
  }

  filterFields(fields: IDynamicFormElement[]): IDynamicFormElement[] {
    const hiddenElements = this.getHiddenFieldsFromStorage();
    return fields.filter((field) => {
      return !hiddenElements.some(
        (hidden) => hidden.id_elemento === field.id_elemento
      );
    });
  }

  setHiddenFieldsToStorage(hiddenElements: IDynamicFormHiddenElement[]): void {
    localStorage.setItem('hiddenElements', JSON.stringify(hiddenElements));
  }

  getHiddenFieldsFromStorage(): IDynamicFormHiddenElement[] {
    return JSON.parse(localStorage.getItem('hiddenElements') ?? '[]');
  }
}
